import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import styles from '../../../styles/Home.module.css'

const BannerBottom = () => {
  return (
    <Container>
      <Row>
        <Col xl={3} className={styles.step}>
          <div>Step into the Future of HR Right Now!</div>
        </Col>
        <Col xl={9} className={styles.step2}>
          <div>
            Trusted by <span style={{ fontWeight: '600' }}>28,000+</span> Companies in <span style={{ fontWeight: '600' }}>200</span> Countries
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default BannerBottom
